var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaasSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 54,
    viewBox: "0 0 65 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M1639.769,492.668a7.973,7.973,0,0,1,0,11.062,7.473,7.473,0,0,1-10.769,0,7.974,7.974,0,0,1,0-11.062,7.473,7.473,0,0,1,10.769,0",
    transform: "translate(-1626.771 -490.378)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.644,
    y1: 0.408,
    x2: 1.149,
    y2: 0.089,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbff01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M1638.868,493.077a7,7,0,0,1,0,9.709,6.556,6.556,0,0,1-9.45,0,7,7,0,0,1,0-9.709,6.559,6.559,0,0,1,9.45,0",
    transform: "translate(-1627.46 -491.067)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.905,
    y1: 0.292,
    x2: 0,
    y2: 0.757,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dea703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfd01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    d: "M1639.807,497.5a6.188,6.188,0,0,1-.365,1.8l-9.013,2.736a6.1,6.1,0,0,1-.659-.584,6.029,6.029,0,0,1-.6-.725Zm-.714-3.223a6.153,6.153,0,0,1,.71,2.525l-11,3.341a6.162,6.162,0,0,1-.736-2.518Zm-.917-1.282a6.23,6.23,0,0,1,.416.5l-10.524,3.195c.017-.216.046-.433.085-.648Z",
    transform: "translate(-1628.064 -492.998)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.614,
    y1: 0.443,
    x2: 1.447,
    y2: 0.026,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff201"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    "data-name": "SVGID",
    d: "M1633.406,503.6a7.825,7.825,0,1,1-7.615,7.821,7.719,7.719,0,0,1,7.615-7.821",
    transform: "translate(-1625.791 -503.604)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.541,
    y1: 0.317,
    x2: 0.684,
    y2: -0.323,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-5",
    "data-name": "SVGID",
    d: "M1633.164,504.293a6.868,6.868,0,1,1-6.684,6.866,6.777,6.777,0,0,1,6.684-6.866",
    transform: "translate(-1626.481 -504.293)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.653,
    y1: 0.024,
    x2: 0.311,
    y2: 1.088,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-6",
    "data-name": "SVGID",
    d: "M1637.068,506.886a6.091,6.091,0,0,1,.984,1.54l-4.49,8.482a5.764,5.764,0,0,1-.867.065,5.649,5.649,0,0,1-.926-.075Zm-2.724-1.76a5.833,5.833,0,0,1,2.242,1.269L1631.1,516.75a5.83,5.83,0,0,1-2.254-1.244Zm-1.53-.24a5.726,5.726,0,0,1,.636.049l-5.244,9.9a6.2,6.2,0,0,1-.385-.52Z",
    transform: "translate(-1627.821 -504.886)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.549,
    y1: 0.406,
    x2: 0.972,
    y2: -0.403,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-7",
    "data-name": "SVGID",
    d: "M1643.884,499.341a7.825,7.825,0,1,1-7.615,7.823,7.721,7.721,0,0,1,7.615-7.823",
    transform: "translate(-1636.269 -499.341)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-8",
    "data-name": "SVGID",
    d: "M1643.642,500.031a6.868,6.868,0,1,1-6.683,6.866,6.777,6.777,0,0,1,6.683-6.866",
    transform: "translate(-1636.959 -500.031)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-9",
    "data-name": "SVGID",
    d: "M1647.547,502.624a6.052,6.052,0,0,1,.983,1.54l-4.49,8.482a5.764,5.764,0,0,1-.867.065,5.832,5.832,0,0,1-.927-.075Zm-2.724-1.76a5.8,5.8,0,0,1,2.24,1.269l-5.481,10.354a5.81,5.81,0,0,1-2.254-1.246Zm-1.531-.24a5.686,5.686,0,0,1,.636.047l-5.243,9.9a6.114,6.114,0,0,1-.386-.522Z",
    transform: "translate(-1638.299 -500.624)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-10",
    "data-name": "SVGID",
    width: 15.446,
    height: 2.195,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: 0.833,
    x2: 0.5,
    y2: 0.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbe00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-11",
    "data-name": "SVGID",
    width: 15.446,
    height: 0.16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.531,
    y1: 8.071,
    x2: 0.435,
    y2: -15.514,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-12",
    "data-name": "SVGID",
    width: 0.236,
    height: 1.725,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfd01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-13",
    "data-name": "SVGID",
    width: 0.236,
    height: 1.725,
    fill: "#ffd801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-24",
    "data-name": "SVGID",
    width: 0.56,
    height: 1.725,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-25",
    "data-name": "SVGID",
    width: 1.147,
    height: 1.725,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-26",
    "data-name": "SVGID",
    width: 0.461,
    height: 1.725,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.5,
    y1: 0.833,
    x2: 0.5,
    y2: 0.073,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0.531,
    y1: 8.07,
    x2: 0.435,
    y2: -15.514,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.531,
    y1: 8.071,
    x2: 0.435,
    y2: -15.514,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 0.5,
    y1: 0.833,
    x2: 0.5,
    y2: 0.073,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 0.531,
    y1: 8.071,
    x2: 0.435,
    y2: -15.514,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 0.5,
    y1: 0.427,
    x2: 0.5,
    y2: -0.136,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-95",
    "data-name": "SVGID",
    d: "M1616.922,508.15a3.909,3.909,0,0,0,1.085-.515l.192.3v.644a.949.949,0,0,1-.854.676.53.53,0,0,1-.424-.316Z",
    transform: "translate(-1616.922 -507.635)",
    fill: "#fccba9",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-96",
    "data-name": "SVGID",
    d: "M.178.025,2.328,0,2.15,15.768,0,15.793Z",
    transform: "matrix(0.875, -0.484, 0.484, 0.875, 0, 1.128)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 0.433,
    y1: 0.524,
    x2: 0.585,
    y2: 0.47,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-97",
    "data-name": "SVGID",
    d: "M.178,0,.334,0,.156,15.768,0,15.77Z",
    transform: "matrix(0.875, -0.484, 0.484, 0.875, 0, 0.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 0.395,
    y1: 0.573,
    x2: 0.721,
    y2: 0.346,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-98",
    "data-name": "SVGID",
    d: "M0,.019,1.693,0l0,.241L0,.26Z",
    transform: "translate(0 0.82) rotate(-28.973)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 0.568,
    y1: 0.442,
    x2: 1.09,
    y2: -0.008,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-99",
    "data-name": "SVGID",
    d: "M0,.019,1.693,0l0,.241L0,.26Z",
    transform: "translate(0 0.82) rotate(-28.971)",
    fill: "#ffd801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 0.568,
    y1: 0.442,
    x2: 1.091,
    y2: -0.008,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-100",
    "data-name": "SVGID",
    d: "M0,.019,1.693,0l0,.241L0,.26Z",
    transform: "matrix(0.875, -0.484, 0.484, 0.875, 0, 0.82)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 0.568,
    y1: 0.442,
    x2: 1.09,
    y2: -0.008,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-101",
    "data-name": "SVGID",
    d: "M0,.019,1.692,0l0,.241L0,.26Z",
    transform: "translate(0 0.82) rotate(-28.973)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-102",
    "data-name": "SVGID",
    d: "M0,.019,1.692,0l0,.241L0,.26Z",
    transform: "translate(0 0.82) rotate(-28.975)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 0.568,
    y1: 0.442,
    x2: 1.091,
    y2: -0.007,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-105",
    "data-name": "SVGID",
    d: "M0,.019,1.693,0l0,.241L0,.26Z",
    transform: "translate(0 0.82) rotate(-28.971)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 0.568,
    y1: 0.442,
    x2: 1.091,
    y2: -0.008,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 0.568,
    y1: 0.442,
    x2: 1.09,
    y2: -0.008,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-108",
    "data-name": "SVGID",
    d: "M0,.019,1.692,0l0,.241L0,.26Z",
    transform: "translate(0 0.82) rotate(-28.971)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 0.568,
    y1: 0.442,
    x2: 1.09,
    y2: -0.008,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 0.568,
    y1: 0.442,
    x2: 1.091,
    y2: -0.008,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-110",
    "data-name": "SVGID",
    d: "M.006.019,1.7,0,1.69.571,0,.591Z",
    transform: "matrix(0.875, -0.484, 0.484, 0.875, 0, 0.822)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 0.562,
    y1: 0.454,
    x2: 1.037,
    y2: 0.103,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-111",
    "data-name": "SVGID",
    d: "M.013.019,1.7,0,1.69,1.17,0,1.19Z",
    transform: "translate(0 0.825) rotate(-28.972)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 0.553,
    y1: 0.467,
    x2: 0.962,
    y2: 0.215,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-112",
    "data-name": "SVGID",
    d: "M.005.019,1.7,0,1.69.47,0,.49Z",
    transform: "translate(0 0.821) rotate(-28.973)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 0.563,
    y1: 0.451,
    x2: 1.052,
    y2: 0.075,
    xlinkHref: "#linear-gradient-12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maas-small",
    transform: "translate(3626 -3409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13611",
    "data-name": "Path 13611",
    d: "M1622.663,506.974h36.377a1.813,1.813,0,0,1,1.783,1.831v25.08a1.813,1.813,0,0,1-1.783,1.831h-36.377a1.813,1.813,0,0,1-1.784-1.831v-25.08a1.813,1.813,0,0,1,1.784-1.831",
    transform: "translate(-5236.91 2923.56)",
    fill: "#0d3f68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13612",
    "data-name": "Path 13612",
    d: "M1654,510.566h-33.6l.174,1.168-1.572-.875v-2.088h0a1.652,1.652,0,0,1,1.44-1.8H1654Z",
    transform: "translate(-5236.928 2924.374)",
    fill: "#0d3f68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11314",
    "data-name": "Group 11314",
    transform: "translate(-3608.016 3409)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9973",
    "data-name": "Rectangle 9973",
    width: 16.716,
    height: 17.172,
    transform: "translate(-0.743 -0.764)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11316",
    "data-name": "Group 11316",
    transform: "translate(-3607.092 3409.957)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9974",
    "data-name": "Rectangle 9974",
    width: 14.672,
    height: 15.072,
    transform: "translate(-0.653 -0.671)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13613",
    "data-name": "Path 13613",
    d: "M1638.678,493.165a6.793,6.793,0,0,1,0,9.422,6.366,6.366,0,0,1-9.172,0,6.793,6.793,0,0,1,0-9.422,6.364,6.364,0,0,1,9.172,0",
    transform: "translate(-5234.503 2918.946)",
    fill: "#febf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11318",
    "data-name": "Group 11318",
    transform: "translate(-3606.283 3412.635)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9975",
    "data-name": "Rectangle 9975",
    width: 11.744,
    height: 9.045,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13614",
    "data-name": "Path 13614",
    d: "M1629.549,494.253l.469-.115a.282.282,0,0,1,.27.075l.35.34a.053.053,0,0,0,.062.008.055.055,0,0,0,.026-.06l-.112-.481a.3.3,0,0,1,.072-.277l.332-.359a.053.053,0,0,0,.007-.064.049.049,0,0,0-.057-.026l-.47.115a.276.276,0,0,1-.269-.074l-.351-.341a.049.049,0,0,0-.062-.007.052.052,0,0,0-.025.058l.112.483a.3.3,0,0,1-.073.276l-.331.361a.054.054,0,0,0-.008.064.051.051,0,0,0,.058.025m-.372-.914.18-.622a.376.376,0,0,1,.258-.265l.6-.185a.072.072,0,0,0,0-.136l-.6-.184a.378.378,0,0,1-.258-.265l-.18-.621a.067.067,0,0,0-.066-.05.068.068,0,0,0-.066.05l-.179.621a.382.382,0,0,1-.258.265l-.6.184a.072.072,0,0,0,0,.136l.6.185a.379.379,0,0,1,.258.265l.179.622a.068.068,0,0,0,.066.05A.067.067,0,0,0,1629.177,493.339Z",
    transform: "translate(-5234.301 2918.868)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11320",
    "data-name": "Group 11320",
    transform: "translate(-3609.298 3426.663)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9976",
    "data-name": "Rectangle 9976",
    width: 15.229,
    height: 15.644,
    transform: "translate(0 -0.001)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11322",
    "data-name": "Group 11322",
    transform: "translate(-3608.375 3427.616)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9977",
    "data-name": "Rectangle 9977",
    width: 13.367,
    height: 13.731,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13615",
    "data-name": "Path 13615",
    d: "M1633.113,504.44a6.665,6.665,0,1,1-6.487,6.662,6.575,6.575,0,0,1,6.487-6.662",
    transform: "translate(-5234.807 2923.379)",
    fill: "#febf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11324",
    "data-name": "Group 11324",
    transform: "translate(-3606.586 3428.436)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9978",
    "data-name": "Rectangle 9978",
    width: 10.231,
    height: 12.087,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11326",
    "data-name": "Group 11326",
    transform: "translate(-3595.59 3420.97)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9979",
    "data-name": "Rectangle 9979",
    width: 15.229,
    height: 15.644,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11328",
    "data-name": "Group 11328",
    transform: "translate(-3594.652 3421.914)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9980",
    "data-name": "Rectangle 9980",
    width: 13.367,
    height: 13.731,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13616",
    "data-name": "Path 13616",
    d: "M1643.591,500.177a6.665,6.665,0,1,1-6.486,6.663,6.575,6.575,0,0,1,6.486-6.663",
    transform: "translate(-5231.559 2921.937)",
    fill: "#febf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11330",
    "data-name": "Group 11330",
    transform: "translate(-3592.84 3422.727)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9981",
    "data-name": "Rectangle 9981",
    width: 10.231,
    height: 12.087,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13617",
    "data-name": "Path 13617",
    d: "M1621.423,506.106l31.308,1.1a1.354,1.354,0,0,1,1.3,1.4l-.647,17.624a1.358,1.358,0,0,1-1.395,1.307l-31.309-1.106a1.352,1.352,0,0,1-1.295-1.4l.645-17.622a1.359,1.359,0,0,1,1.4-1.307",
    transform: "translate(-5236.796 2923.759)",
    fill: "#b3e5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13618",
    "data-name": "Path 13618",
    d: "M1623.056,507.949l31.258-1.106a1.354,1.354,0,0,1,1.391,1.307l.613,17.621a1.355,1.355,0,0,1-1.3,1.4l-31.257,1.105a1.354,1.354,0,0,1-1.391-1.307l-.613-17.622a1.354,1.354,0,0,1,1.3-1.4",
    transform: "translate(-5236.554 2923.999)",
    fill: "#81dcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13619",
    "data-name": "Path 13619",
    d: "M1619.808,509.178h37.355a1.814,1.814,0,0,1,1.782,1.833v25.08a1.813,1.813,0,0,1-1.782,1.831h-36.377a1.813,1.813,0,0,1-1.782-1.831V508.268a.866.866,0,0,0,.8.91",
    transform: "translate(-5236.928 2924.061)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13620",
    "data-name": "Path 13620",
    d: "M1641.625,518l.03-.017.028-.017.54-.291a3.113,3.113,0,0,1,1.48-.375h9.219l.005,0a1.11,1.11,0,0,0,.205-.032,1.3,1.3,0,0,0,.42-.961v6.63c-.767.546-1.019-.278-.674,1.1a1.178,1.178,0,0,1-.485.143l-.007,0h-9.224a3.108,3.108,0,0,1-1.538-.407Zm.334-.164v0c.028-.012.055-.024.084-.033C1642.015,517.812,1641.987,517.823,1641.958,517.836Z",
    transform: "translate(-5230.135 2927.537)",
    fill: "#0d3f68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13621",
    "data-name": "Path 13621",
    d: "M1643.6,517.591h9.224v0a1.276,1.276,0,0,0,1.166-1.284v6.585a1.277,1.277,0,0,1-1.164,1.285v0H1643.6a3.294,3.294,0,0,1,0-6.585",
    transform: "translate(-5230.553 2927.537)",
    fill: "#055fa8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13622",
    "data-name": "Path 13622",
    d: "M1643.421,518.213a1.933,1.933,0,1,1-1.881,1.932,1.907,1.907,0,0,1,1.881-1.932",
    transform: "translate(-5230.015 2928.288)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13623",
    "data-name": "Path 13623",
    d: "M1621.844,511.556l.64-.157a.381.381,0,0,1,.367.1l.477.463a.068.068,0,0,0,.085.011.075.075,0,0,0,.034-.08l-.153-.656a.406.406,0,0,1,.1-.379l.451-.49a.074.074,0,0,0,.009-.087.07.07,0,0,0-.078-.035l-.639.157a.381.381,0,0,1-.367-.1l-.477-.463a.07.07,0,0,0-.085-.01.073.073,0,0,0-.034.08l.153.656a.407.407,0,0,1-.1.377l-.451.49a.073.073,0,0,0-.011.087.068.068,0,0,0,.078.035m-.506-1.246.246-.846a.517.517,0,0,1,.351-.362l.823-.251a.1.1,0,0,0,.068-.093.1.1,0,0,0-.068-.092l-.823-.251a.517.517,0,0,1-.351-.362l-.246-.846a.092.092,0,0,0-.178,0l-.246.846a.517.517,0,0,1-.353.362l-.824.251a.1.1,0,0,0-.066.092.1.1,0,0,0,.066.093l.824.251a.517.517,0,0,1,.353.362l.246.846a.093.093,0,0,0,.178,0Z",
    transform: "translate(-5236.694 2924.429)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11332",
    "data-name": "Group 11332",
    transform: "translate(-3614.756 3460.436)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9982",
    "data-name": "Rectangle 9982",
    width: 15.446,
    height: 2.195,
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11334",
    "data-name": "Group 11334",
    transform: "translate(-3614.756 3460.436)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9983",
    "data-name": "Rectangle 9983",
    width: 15.446,
    height: 0.16,
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9984",
    "data-name": "Rectangle 9984",
    width: 15.446,
    height: 0.16,
    transform: "translate(-3614.756 3462.472)",
    fill: "#d4a600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11336",
    "data-name": "Group 11336",
    transform: "translate(-3600.337 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9985",
    "data-name": "Rectangle 9985",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-113",
    "data-name": "SVGID",
    width: 0.236,
    height: 1.725,
    transform: "translate(-3601.34 3460.671)",
    fill: "#ffd801"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11338",
    "data-name": "Group 11338",
    transform: "translate(-3601.34 3460.671)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9986",
    "data-name": "Rectangle 9986",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11340",
    "data-name": "Group 11340",
    transform: "translate(-3602.344 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9987",
    "data-name": "Rectangle 9987",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11342",
    "data-name": "Group 11342",
    transform: "translate(-3603.347 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9988",
    "data-name": "Rectangle 9988",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11344",
    "data-name": "Group 11344",
    transform: "translate(-3604.351 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9989",
    "data-name": "Rectangle 9989",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11346",
    "data-name": "Group 11346",
    transform: "translate(-3605.354 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9990",
    "data-name": "Rectangle 9990",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11348",
    "data-name": "Group 11348",
    transform: "translate(-3606.357 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9991",
    "data-name": "Rectangle 9991",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11350",
    "data-name": "Group 11350",
    transform: "translate(-3607.361 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9992",
    "data-name": "Rectangle 9992",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11352",
    "data-name": "Group 11352",
    transform: "translate(-3608.364 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9993",
    "data-name": "Rectangle 9993",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11354",
    "data-name": "Group 11354",
    transform: "translate(-3609.367 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9994",
    "data-name": "Rectangle 9994",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11356",
    "data-name": "Group 11356",
    transform: "translate(-3610.371 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9995",
    "data-name": "Rectangle 9995",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11358",
    "data-name": "Group 11358",
    transform: "translate(-3611.374 3460.671)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9996",
    "data-name": "Rectangle 9996",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11360",
    "data-name": "Group 11360",
    transform: "translate(-3612.379 3460.671)",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9997",
    "data-name": "Rectangle 9997",
    width: 0.56,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11362",
    "data-name": "Group 11362",
    transform: "translate(-3613.791 3460.671)",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9998",
    "data-name": "Rectangle 9998",
    width: 1.147,
    height: 1.725,
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11364",
    "data-name": "Group 11364",
    transform: "translate(-3614.234 3460.671)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9999",
    "data-name": "Rectangle 9999",
    width: 0.461,
    height: 1.725,
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11366",
    "data-name": "Group 11366",
    transform: "translate(-3612.661 3458.241)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10000",
    "data-name": "Rectangle 10000",
    width: 15.446,
    height: 2.195,
    fill: "url(#linear-gradient-27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11368",
    "data-name": "Group 11368",
    transform: "translate(-3612.661 3458.241)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10001",
    "data-name": "Rectangle 10001",
    width: 15.446,
    height: 0.16,
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10002",
    "data-name": "Rectangle 10002",
    width: 15.446,
    height: 0.16,
    transform: "translate(-3612.661 3460.276)",
    fill: "#d4a600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11370",
    "data-name": "Group 11370",
    transform: "translate(-3598.228 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10003",
    "data-name": "Rectangle 10003",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-114",
    "data-name": "SVGID",
    width: 0.236,
    height: 1.725,
    transform: "translate(-3599.231 3458.476)",
    fill: "#ffd801"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11372",
    "data-name": "Group 11372",
    transform: "translate(-3599.231 3458.476)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10004",
    "data-name": "Rectangle 10004",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11374",
    "data-name": "Group 11374",
    transform: "translate(-3600.234 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10005",
    "data-name": "Rectangle 10005",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11376",
    "data-name": "Group 11376",
    transform: "translate(-3601.238 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10006",
    "data-name": "Rectangle 10006",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11378",
    "data-name": "Group 11378",
    transform: "translate(-3602.241 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10007",
    "data-name": "Rectangle 10007",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11380",
    "data-name": "Group 11380",
    transform: "translate(-3603.244 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10008",
    "data-name": "Rectangle 10008",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11382",
    "data-name": "Group 11382",
    transform: "translate(-3604.248 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10009",
    "data-name": "Rectangle 10009",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11384",
    "data-name": "Group 11384",
    transform: "translate(-3605.251 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10010",
    "data-name": "Rectangle 10010",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11386",
    "data-name": "Group 11386",
    transform: "translate(-3606.254 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10011",
    "data-name": "Rectangle 10011",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11388",
    "data-name": "Group 11388",
    transform: "translate(-3607.258 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10012",
    "data-name": "Rectangle 10012",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11390",
    "data-name": "Group 11390",
    transform: "translate(-3608.261 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10013",
    "data-name": "Rectangle 10013",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11392",
    "data-name": "Group 11392",
    transform: "translate(-3609.265 3458.476)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10014",
    "data-name": "Rectangle 10014",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11394",
    "data-name": "Group 11394",
    transform: "translate(-3610.27 3458.476)",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10015",
    "data-name": "Rectangle 10015",
    width: 0.56,
    height: 1.725,
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11396",
    "data-name": "Group 11396",
    transform: "translate(-3611.683 3458.476)",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10016",
    "data-name": "Rectangle 10016",
    width: 1.147,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11398",
    "data-name": "Group 11398",
    transform: "translate(-3612.41 3458.476)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10017",
    "data-name": "Rectangle 10017",
    width: 0.461,
    height: 1.725,
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11400",
    "data-name": "Group 11400",
    transform: "translate(-3615.039 3456.046)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10018",
    "data-name": "Rectangle 10018",
    width: 15.446,
    height: 2.195,
    fill: "url(#linear-gradient-27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11402",
    "data-name": "Group 11402",
    transform: "translate(-3615.039 3456.046)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10019",
    "data-name": "Rectangle 10019",
    width: 15.446,
    height: 0.16,
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10020",
    "data-name": "Rectangle 10020",
    width: 15.446,
    height: 0.16,
    transform: "translate(-3615.039 3458.081)",
    fill: "#d4a600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11404",
    "data-name": "Group 11404",
    transform: "translate(-3600.622 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10021",
    "data-name": "Rectangle 10021",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-115",
    "data-name": "SVGID",
    width: 0.236,
    height: 1.725,
    transform: "translate(-3601.626 3456.281)",
    fill: "#ffd801"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11406",
    "data-name": "Group 11406",
    transform: "translate(-3601.626 3456.281)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10022",
    "data-name": "Rectangle 10022",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11408",
    "data-name": "Group 11408",
    transform: "translate(-3602.629 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10023",
    "data-name": "Rectangle 10023",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11410",
    "data-name": "Group 11410",
    transform: "translate(-3603.633 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10024",
    "data-name": "Rectangle 10024",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11412",
    "data-name": "Group 11412",
    transform: "translate(-3604.636 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10025",
    "data-name": "Rectangle 10025",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11414",
    "data-name": "Group 11414",
    transform: "translate(-3605.639 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10026",
    "data-name": "Rectangle 10026",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11416",
    "data-name": "Group 11416",
    transform: "translate(-3606.643 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10027",
    "data-name": "Rectangle 10027",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11418",
    "data-name": "Group 11418",
    transform: "translate(-3607.646 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10028",
    "data-name": "Rectangle 10028",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11420",
    "data-name": "Group 11420",
    transform: "translate(-3608.649 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10029",
    "data-name": "Rectangle 10029",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11422",
    "data-name": "Group 11422",
    transform: "translate(-3609.653 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10030",
    "data-name": "Rectangle 10030",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11424",
    "data-name": "Group 11424",
    transform: "translate(-3610.656 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10031",
    "data-name": "Rectangle 10031",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11426",
    "data-name": "Group 11426",
    transform: "translate(-3611.659 3456.281)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10032",
    "data-name": "Rectangle 10032",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11428",
    "data-name": "Group 11428",
    transform: "translate(-3612.665 3456.281)",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10033",
    "data-name": "Rectangle 10033",
    width: 0.56,
    height: 1.725,
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11430",
    "data-name": "Group 11430",
    transform: "translate(-3614.077 3456.281)",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10034",
    "data-name": "Rectangle 10034",
    width: 1.147,
    height: 1.725,
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11432",
    "data-name": "Group 11432",
    transform: "translate(-3614.526 3456.281)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10035",
    "data-name": "Rectangle 10035",
    width: 0.461,
    height: 1.725,
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11434",
    "data-name": "Group 11434",
    transform: "translate(-3613.49 3453.851)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10036",
    "data-name": "Rectangle 10036",
    width: 15.446,
    height: 2.195,
    fill: "url(#linear-gradient-61)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11436",
    "data-name": "Group 11436",
    transform: "translate(-3613.49 3453.851)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10037",
    "data-name": "Rectangle 10037",
    width: 15.446,
    height: 0.16,
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10038",
    "data-name": "Rectangle 10038",
    width: 15.446,
    height: 0.16,
    transform: "translate(-3613.49 3455.886)",
    fill: "#d4a600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11438",
    "data-name": "Group 11438",
    transform: "translate(-3599.062 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10039",
    "data-name": "Rectangle 10039",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-63)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-116",
    "data-name": "SVGID",
    width: 0.236,
    height: 1.725,
    transform: "translate(-3600.066 3454.086)",
    fill: "#ffd801"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11440",
    "data-name": "Group 11440",
    transform: "translate(-3600.066 3454.086)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10040",
    "data-name": "Rectangle 10040",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11442",
    "data-name": "Group 11442",
    transform: "translate(-3601.069 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10041",
    "data-name": "Rectangle 10041",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-65)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11444",
    "data-name": "Group 11444",
    transform: "translate(-3602.072 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10042",
    "data-name": "Rectangle 10042",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-66)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11446",
    "data-name": "Group 11446",
    transform: "translate(-3603.076 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10043",
    "data-name": "Rectangle 10043",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11448",
    "data-name": "Group 11448",
    transform: "translate(-3604.079 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10044",
    "data-name": "Rectangle 10044",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-65)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11450",
    "data-name": "Group 11450",
    transform: "translate(-3605.083 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10045",
    "data-name": "Rectangle 10045",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-69)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11452",
    "data-name": "Group 11452",
    transform: "translate(-3606.086 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10046",
    "data-name": "Rectangle 10046",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-70)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11454",
    "data-name": "Group 11454",
    transform: "translate(-3607.089 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10047",
    "data-name": "Rectangle 10047",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-63)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11456",
    "data-name": "Group 11456",
    transform: "translate(-3608.093 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10048",
    "data-name": "Rectangle 10048",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11458",
    "data-name": "Group 11458",
    transform: "translate(-3609.096 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10049",
    "data-name": "Rectangle 10049",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-70)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11460",
    "data-name": "Group 11460",
    transform: "translate(-3610.099 3454.086)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10050",
    "data-name": "Rectangle 10050",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-66)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11462",
    "data-name": "Group 11462",
    transform: "translate(-3611.104 3454.086)",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10051",
    "data-name": "Rectangle 10051",
    width: 0.56,
    height: 1.725,
    fill: "url(#linear-gradient-75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11464",
    "data-name": "Group 11464",
    transform: "translate(-3612.517 3454.086)",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10052",
    "data-name": "Rectangle 10052",
    width: 1.147,
    height: 1.725,
    fill: "url(#linear-gradient-64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11466",
    "data-name": "Group 11466",
    transform: "translate(-3613.245 3454.086)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10053",
    "data-name": "Rectangle 10053",
    width: 0.461,
    height: 1.725,
    fill: "url(#linear-gradient-69)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11468",
    "data-name": "Group 11468",
    transform: "translate(-3615.617 3451.911)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10054",
    "data-name": "Rectangle 10054",
    width: 15.446,
    height: 2.195,
    fill: "url(#linear-gradient-61)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11470",
    "data-name": "Group 11470",
    transform: "translate(-3615.617 3451.956)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10055",
    "data-name": "Rectangle 10055",
    width: 15.446,
    height: 0.16,
    fill: "url(#linear-gradient-79)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10056",
    "data-name": "Rectangle 10056",
    width: 15.446,
    height: 0.16,
    transform: "translate(-3615.617 3453.691)",
    fill: "#d4a600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11472",
    "data-name": "Group 11472",
    transform: "translate(-3601.206 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10057",
    "data-name": "Rectangle 10057",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-80)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-117",
    "data-name": "SVGID",
    width: 0.236,
    height: 1.725,
    transform: "translate(-3602.209 3452.151)",
    fill: "#ffd801"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11474",
    "data-name": "Group 11474",
    transform: "translate(-3602.209 3452.151)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10058",
    "data-name": "Rectangle 10058",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-81)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11476",
    "data-name": "Group 11476",
    transform: "translate(-3603.212 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10059",
    "data-name": "Rectangle 10059",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11478",
    "data-name": "Group 11478",
    transform: "translate(-3604.216 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10060",
    "data-name": "Rectangle 10060",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-80)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11480",
    "data-name": "Group 11480",
    transform: "translate(-3605.219 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10061",
    "data-name": "Rectangle 10061",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-84)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11482",
    "data-name": "Group 11482",
    transform: "translate(-3606.222 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10062",
    "data-name": "Rectangle 10062",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-85)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11484",
    "data-name": "Group 11484",
    transform: "translate(-3607.226 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10063",
    "data-name": "Rectangle 10063",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-81)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11486",
    "data-name": "Group 11486",
    transform: "translate(-3608.229 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10064",
    "data-name": "Rectangle 10064",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-87)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11488",
    "data-name": "Group 11488",
    transform: "translate(-3609.233 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10065",
    "data-name": "Rectangle 10065",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-80)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11490",
    "data-name": "Group 11490",
    transform: "translate(-3610.236 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10066",
    "data-name": "Rectangle 10066",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-81)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11492",
    "data-name": "Group 11492",
    transform: "translate(-3611.239 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10067",
    "data-name": "Rectangle 10067",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11494",
    "data-name": "Group 11494",
    transform: "translate(-3612.243 3452.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10068",
    "data-name": "Rectangle 10068",
    width: 0.236,
    height: 1.725,
    fill: "url(#linear-gradient-91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11496",
    "data-name": "Group 11496",
    transform: "translate(-3613.248 3452.151)",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10069",
    "data-name": "Rectangle 10069",
    width: 0.56,
    height: 1.725,
    fill: "url(#linear-gradient-84)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11498",
    "data-name": "Group 11498",
    transform: "translate(-3614.375 3452.151)",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10070",
    "data-name": "Rectangle 10070",
    width: 1.147,
    height: 1.725,
    fill: "url(#linear-gradient-82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11500",
    "data-name": "Group 11500",
    transform: "translate(-3615.124 3452.151)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10071",
    "data-name": "Rectangle 10071",
    width: 0.461,
    height: 1.725,
    fill: "url(#linear-gradient-84)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14094",
    "data-name": "Path 14094",
    d: "M.007,0,1.082,0,1.075,2.1,0,2.106Z",
    transform: "translate(-3626 3432.892) rotate(-8.024)",
    fill: "#3d3179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14095",
    "data-name": "Path 14095",
    d: "M.007,0,1.082,0,1.075,2.1,0,2.106Z",
    transform: "translate(-3626 3432.892) rotate(-8.024)",
    fill: "#004990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13624",
    "data-name": "Path 13624",
    d: "M1615.278,510.912a4.246,4.246,0,0,1,1.468.322,22.366,22.366,0,0,1-.554,2.7.69.69,0,0,1-.686.558c-.274-.022-.382-.483-.406-1.071a16.107,16.107,0,0,1,.178-2.5",
    transform: "translate(-5238.298 2925.757)",
    fill: "#ffc197",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13625",
    "data-name": "Path 13625",
    d: "M1616.747,512.573a7.742,7.742,0,0,1-1.711-.152,7.893,7.893,0,0,1,.755-3.535c.182-.108.845-.52,1.007-.347.653.7.139,3.4-.051,4.034",
    transform: "translate(-5238.318 2924.911)",
    fill: "#66d0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13626",
    "data-name": "Path 13626",
    d: "M1613.091,509.155c.534-1.2,1.991-.581.72.494.18,1.4,2.145,3.164,2.7,4.364.279.834.126,1.518-.1,1.6-1.163.428-3.646-5.717-3.317-6.461",
    transform: "translate(-5239.01 2924.865)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13627",
    "data-name": "Path 13627",
    d: "M1617.341,527.219l.908,1.074c.143.147.561.527,1.091,1,.406-.054.682-.483.562-.681s-1.654-1.873-1.654-1.873Z",
    transform: "translate(-5237.511 2931.214)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13628",
    "data-name": "Path 13628",
    d: "M1620.254,528.342c-.112.158-.555.723-.6.781s-.063.229-.09.265a2.188,2.188,0,0,1-.475.387c-.063.046-.858.931-.88.921a.229.229,0,0,1-.085-.233c.019-.058.117-.294.224-.583s.205-.6.245-.746-.012-.257.107-.416.42-.137.521-.343-.073-.393,0-.492.444-.081,1.032.459",
    transform: "translate(-5237.239 2931.639)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13629",
    "data-name": "Path 13629",
    d: "M1620.226,528.206h.008a.58.58,0,0,1,.171.1,3.972,3.972,0,0,1-.824,1.128c-.6.653-1.114,1.194-1.395,1.12h0c.041-.013.816-.875.879-.921a2.178,2.178,0,0,0,.475-.387c.027-.036.048-.208.091-.265s.478-.613.594-.775",
    transform: "translate(-5237.214 2931.781)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13630",
    "data-name": "Path 13630",
    d: "M1618.493,528.739a2.889,2.889,0,0,1,.035-.452.843.843,0,0,1,.352-.079.618.618,0,0,1,.065.166c-.13.069-.295.093-.377.2a.408.408,0,0,0-.076.162",
    transform: "translate(-5237.106 2931.781)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13631",
    "data-name": "Path 13631",
    d: "M1614.71,527.178l-.173,1.411c-.012.208-.007.781,0,1.5.31.273.805.2.869-.025s.252-2.516.252-2.516Z",
    transform: "translate(-5238.496 2931.384)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13632",
    "data-name": "Path 13632",
    d: "M1616.2,529.985c-.188.021-.894.058-.964.064s-.209.106-.253.108a2.069,2.069,0,0,1-.6-.105c-.076-.017-1.248-.035-1.256-.058a.231.231,0,0,1,.113-.221c.054-.025.29-.107.57-.218s.57-.241.705-.311.178-.18.374-.2.378.229.6.169.236-.318.358-.327.354.285.355,1.095",
    transform: "translate(-5238.986 2932.047)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13633",
    "data-name": "Path 13633",
    d: "M1616.2,529.68l.005.005a.608.608,0,0,1,.041.2,3.834,3.834,0,0,1-1.367.122c-.876-.024-1.609-.054-1.743-.319h0c.036.024,1.18.04,1.254.057a2.058,2.058,0,0,0,.6.105c.043,0,.184-.1.253-.108s.763-.043.959-.062",
    transform: "translate(-5238.986 2932.353)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13634",
    "data-name": "Path 13634",
    d: "M1614.312,529.117a2.787,2.787,0,0,1,.351-.276c.036.006.293.175.293.216a.639.639,0,0,1-.077.161c-.138-.051-.266-.162-.4-.151a.377.377,0,0,0-.169.05",
    transform: "translate(-5238.572 2932.028)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13635",
    "data-name": "Path 13635",
    d: "M1616.49,515.556c-.963,1.368-4.352,5.753-3.149,8.682,1.125,2.591,5.5,7.635,6.02,8.114a4.1,4.1,0,0,0,1-1.226,2.173,2.173,0,0,1-.425-.732,1.405,1.405,0,0,0,.066-.441c-.03-.189-.755-.916-.813-1.122a3.858,3.858,0,0,0-.087-.476c-.067-.147-.94-1.215-1.073-1.444s-.187-1.021-.54-1.346a5.012,5.012,0,0,1-1.91-2.429c-.548-1.6,3.407-5.109,3.93-7.319Z",
    transform: "translate(-5239.002 2926.883)",
    fill: "#0d3f68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13636",
    "data-name": "Path 13636",
    d: "M1617.552,515.8c-.159,1.039-2.806,12.823-3.055,17.294.26.067,1.4.242,1.661.254a4.043,4.043,0,0,1,.357-1.35,4.154,4.154,0,0,1-.015-.654c.05-.223.454-.524.517-.8.02-.108-.084-.444-.035-.606s.283-.182.332-.382-.218-.677-.17-.811.747-.892.737-1.192c-.024-.2-.353-.279-.315-.562.341-2.543,3.2-7.55,3.4-11.51l-2.192.3Z",
    transform: "translate(-5238.507 2926.853)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13637",
    "data-name": "Path 13637",
    d: "M1621.092,509.1a22.184,22.184,0,0,1,2.007,2.561l-.021.028a13.061,13.061,0,0,1-1.118,1.066c-.1.086-.18.15-.216.176a15.378,15.378,0,0,1-1.228-1.555c.022,2.418.031,4.99.064,7.3-.077.019-.162.036-.253.051-1.391.234-4.254.01-4.72-.349.03-.421.113-3.744.192-6.359.05-1.665.1-3.042.127-3.2,1.311-.857,4.209-.621,5.167.286",
    transform: "translate(-5238.118 2924.732)",
    fill: "#81dcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13638",
    "data-name": "Path 13638",
    d: "M1619.8,517.094c.141-.289,1.811-3.51,2.03-4.033a9.377,9.377,0,0,0-.953-1.261,13.11,13.11,0,0,0,1.118-1.065,8.218,8.218,0,0,1,1.321,2.333c-.034,1.354-2.4,3.626-3.224,4.7a1.27,1.27,0,0,1-1.359,1.042c-.177-.037.159-.624.511-1.036.09-.015.176-.032.253-.051l0-.206-.005-.4a.846.846,0,0,1,.312-.018",
    transform: "translate(-5237.039 2925.619)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-118",
    "data-name": "SVGID",
    d: "M1616.922,508.15a3.909,3.909,0,0,0,1.085-.515l.192.3v.644a.949.949,0,0,1-.854.676.53.53,0,0,1-.424-.316Z",
    transform: "translate(-5237.657 2924.644)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11502",
    "data-name": "Group 11502",
    transform: "translate(-3620.735 3432.279)",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10074",
    "data-name": "Rectangle 10074",
    width: 1.278,
    height: 1.631,
    transform: "translate(-0.001 0)",
    fill: "#fccba9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13639",
    "data-name": "Path 13639",
    d: "M1616.726,508.1c.007.04.139.1.239.069s.128-.082.112-.118-.139-.053-.2-.037-.154.043-.147.086",
    transform: "translate(-5237.726 2924.792)",
    fill: "#e5ac8e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13640",
    "data-name": "Path 13640",
    d: "M1617.311,508.331c.139.035.282.309.361-.06.024-.1.329-.229.34-.271a3.3,3.3,0,0,0,.105-.67c-.027-.1-.233-.158-.254-.23s.124-.291-.05-.4-.446.119-.605.1c-.092-.011-.159-.125-.27-.189a.348.348,0,0,0-.246-.036c-.5.184-.3,1.609.027,2.222.024.013-.062-.329-.016-.368a1.3,1.3,0,0,1,.608-.1",
    transform: "translate(-5237.843 2924.263)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13641",
    "data-name": "Path 13641",
    d: "M1617.751,507.322s-.058.49-.077.6c.282-.114.535-.548.372-.692a.225.225,0,0,0-.3.093",
    transform: "translate(-5237.394 2924.504)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13642",
    "data-name": "Path 13642",
    d: "M1617.073,508.891c.065-.015.189,0,.2.037s-.01.092-.112.118-.232-.029-.239-.069.083-.069.147-.086m1.128-1.244a3.33,3.33,0,0,1-.105.67c-.011.042-.316.175-.34.271-.078.369-.222.094-.36.06a1.294,1.294,0,0,0-.608.1c-.046.039-.047.255-.07.243a1.562,1.562,0,0,0,.278.37.621.621,0,0,0,.366.074.836.836,0,0,0,.54-.255,1.675,1.675,0,0,0,.305-.691h0c.019-.109.077-.6.077-.6a.188.188,0,0,1,.227-.04c.057.051.1.372-.3.64l.113.15a.358.358,0,0,1,.141.089c.3-.2.127-.358.189-.491s.279-.305.313-.5a.777.777,0,0,0-.085-.418c-.023-.093.118-.541.1-.624s-.169-.1-.2-.154c-.041-.089.068-.286-.011-.4s-.274-.026-.3-.033c-.118-.033-.335-.329-.713-.35s-.425.246-.49.262-.269-.11-.471-.067a.453.453,0,0,0-.342.264.287.287,0,0,0-.277.218c-.059.212.109.483.12.548.016.1-.151.2-.143.318.008.136.239.24.322.348,0-.371.088-.673.3-.752a.348.348,0,0,1,.246.036c.11.064.178.177.27.189.159.022.429-.2.605-.1s.028.326.05.4S1618.174,507.549,1618.2,507.646Z",
    transform: "translate(-5237.927 2923.962)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13643",
    "data-name": "Path 13643",
    d: "M1651.072,534.225c.005-.3.027-.6.061-.892l.028-.006V533.1c.262-1.96,1.011-3.883,1.307-5.542.323-1.813-.125-1.876.466-4.044.6-2.21,2.27-4.953,2.1-7.531a16.76,16.76,0,0,1-1.741-.143c-.788-.025-.955-.373-1.544.028-.239,1.5-.859,3.793-1.253,5.8-.75,3.815-.482,7.83-.4,11.765-.38.33-1.151,1.686-1.356,1.818l.007.025a.442.442,0,0,0,.4.239,3.006,3.006,0,0,0,1.926-1.293",
    transform: "translate(-5227.792 2926.93)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13644",
    "data-name": "Path 13644",
    d: "M1651.007,531c.026,0,.386.1.441,0,.007-.262.165-1.3.163-1.984,0-.314-.142-.406-.166-.62a1.245,1.245,0,0,0-.839.541c-.461.649-.66,1.626-1.234,1.656a.42.42,0,0,1-.406-.263c-.151.134-.928.153-.868.39a1.745,1.745,0,0,0,1.6.393c.5-.11.559-.727,1.213-1.1Z",
    transform: "translate(-5227.939 2931.855)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13645",
    "data-name": "Path 13645",
    d: "M1653.7,511.847a20.916,20.916,0,0,1-4.154-1.378.882.882,0,0,1,.325-1.344c.852.413,2.667.161,3.9.357,1.04.612.4,1.883-.072,2.365",
    transform: "translate(-5227.567 2925.148)",
    fill: "#ffbc00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13646",
    "data-name": "Path 13646",
    d: "M1650.426,511.434a4.617,4.617,0,0,1-1.2-.5.907.907,0,0,1-.185-.269,12.718,12.718,0,0,1-.488-1.676c-.063-.121-.3-.2-.353-.289s.157-.42.112-.565-.119-.219-.147-.35.126-.308.1-.415-.143-.268-.151-.33.348.01.779.071c.391.055.843.121,1.152.14.127.742.131,2.589.562,2.812.16.165,0,1.1-.181,1.372",
    transform: "translate(-5227.915 2924.392)",
    fill: "#ffbc00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13647",
    "data-name": "Path 13647",
    d: "M1664.48,527.847c.338-.311.212-.936-.036-.978-.377-.063-.723-.132-1.04-.2v-.023l-.179-.02c-3.031-.742-3.526-1.953-6.355-2.948-1.171-1.316-.843-5.154-1.423-7.383a3.034,3.034,0,0,0-3.379-.409c-.112,1.869.424,7.709,1.749,9.283s6.632,2.227,9.564,2.557c.25.412,1.515,1.376,1.622,1.6l.026,0a.453.453,0,0,0,.274-.383c.027-.462-.538-.753-1.063-1.12l.243.028",
    transform: "translate(-5226.953 2926.886)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13648",
    "data-name": "Path 13648",
    d: "M1656.538,516.266c.834.8.585,3.734.963,5.524a2.073,2.073,0,0,0,1.582,1.758c-.474.712-5.942,2.1-9.5,1.647-.223-2.1,1.211-7.669,1.739-8.742,1.017-.414.766-.351.766-.351Z",
    transform: "translate(-5227.826 2927.435)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13649",
    "data-name": "Path 13649",
    d: "M1653.333,510.946a20.924,20.924,0,0,0,4.166,1.336.877.877,0,0,0,.489-1.292c-.868-.226-1.976-.95-3.04-1.218-1.193-.114-1.733.5-1.615,1.174",
    transform: "translate(-5226.51 2925.372)",
    fill: "#ffbc00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13650",
    "data-name": "Path 13650",
    d: "M1656.219,510.028a9,9,0,0,1-.1,2.79c-.261,1.447-.81,1.91-.791,2.973.009.512.42,1.341.8,3.077a32.077,32.077,0,0,1-5.2-.046,10.953,10.953,0,0,0,.413-2.772c-.059-.913-.489-2.269-.58-3.288-.338-3.75,1.923-3.915,5.456-2.734",
    transform: "translate(-5227.149 2925.125)",
    fill: "#ffbc00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13651",
    "data-name": "Path 13651",
    d: "M1648.876,505.269c.031.316.265,1.72.422,2.632-.308-.019-.762-.085-1.152-.139,0-.918.007-2,.063-2.525l.683.021-.016.011",
    transform: "translate(-5227.879 2923.796)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13652",
    "data-name": "Path 13652",
    d: "M1648.784,505.846c-.646-.126-.524-.619-.868-1.009-.1-.105-.506-.337-.455-.488.109-.33,1.006.225,1.334.6.014-.011.245-.469.513-.262.041.032-.124.186-.123.459,0,.38,0,.782-.4.7",
    transform: "translate(-5228.111 2923.462)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13653",
    "data-name": "Path 13653",
    d: "M1653.589,508.835c-.038.319-.013.669-.036.97-.1.327-.7.515-.863.506s-.293-.265-.307-.37a2.218,2.218,0,0,1,.026-.29c.035-.268.062-.409.082-.586a1.587,1.587,0,0,0,1.1-.23",
    transform: "translate(-5226.536 2925.064)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13654",
    "data-name": "Path 13654",
    d: "M1652.43,509.36c.017-.117.032-.211.044-.318a1.63,1.63,0,0,0,.958-.147,1.153,1.153,0,0,1-1,.465",
    transform: "translate(-5226.518 2925.098)",
    fill: "#ffc197",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13655",
    "data-name": "Path 13655",
    d: "M1653.679,509.517a1.391,1.391,0,0,1-.786.25c-.7-.005-.907-.78-.784-1.69a.866.866,0,0,1,.871-.812c1.314.038,1.225,1.786.7,2.252",
    transform: "translate(-5226.649 2924.504)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13656",
    "data-name": "Path 13656",
    d: "M1653.564,509.976c-.058-.248-.18-.345-.247-.576-.081-.272.119-.43.007-.713-.077-.194-.271-.214-.363-.275-.141-.094-.107-.286-.266-.332-.211-.061-.3.031-.452,0-.024.069-.055.139-.074.215a.832.832,0,0,1-.17-.751c.113-.218.335-.175.446-.259.156-.121.113-.51.3-.586s.43.187.662.161c.172-.02.421-.493.86-.426.793.119.821,1.045,1.225,1.143.179.042.539-.265.9-.046s.155,1.083.81,1.481c.286.131,1.016.021,1.271.473.138.241-.07.608-.232,1.024-.4,1.025.281,1.159.211,1.53-.108.559-1.057.488-1.2.728-.1.161.03.6-.328.788a1.553,1.553,0,0,1-.955.042c-1.009-.35-.315-1.217-.8-1.773-.357-.407-.525-.336-.933-.558-.246-.133-.515-.272-.592-.556s-.039-.552-.082-.738",
    transform: "translate(-5226.985 2924.152)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13657",
    "data-name": "Path 13657",
    d: "M1659.594,507.4c-.142.283-.862,1.5-1.333,2.289.293.1.739.208,1.121.305.33-.853.709-1.864.844-2.371l-.643-.24.011.017",
    transform: "translate(-5224.777 2924.543)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13658",
    "data-name": "Path 13658",
    d: "M1656.378,512.615a4.561,4.561,0,0,0,1.3-.014.9.9,0,0,0,.269-.182,12.248,12.248,0,0,0,1.052-1.373c.1-.087.352-.074.431-.135s.005-.451.1-.567.189-.159.262-.271-.007-.334.055-.423.23-.2.258-.25-.327-.122-.75-.229c-.382-.1-.826-.207-1.121-.305-.384.644-1.048,2.358-1.529,2.4-.207.093-.4,1.025-.323,1.344",
    transform: "translate(-5225.443 2925.044)",
    fill: "#ffbc00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13659",
    "data-name": "Path 13659",
    d: "M1659.494,507.974c.647.128.709-.377,1.168-.61.134-.058.592-.122.6-.282.016-.348-1.016-.171-1.453.05-.01-.015-.059-.529-.384-.438-.05.014.049.219-.05.474-.138.354-.277.728.12.806",
    transform: "translate(-5224.437 2924.315)",
    fill: "#fccba9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13660",
    "data-name": "Path 13660",
    d: "M1662.927,524.271c0-.028.141-.384.049-.452-.254-.035-1.24-.311-1.9-.384-.3-.035-.409.1-.619.1a1.3,1.3,0,0,0,.431.916c.578.542,1.5.853,1.468,1.441a.43.43,0,0,1-.3.387c.113.169.047.964.282.928a1.838,1.838,0,0,0,.555-1.593c-.051-.517-.642-.651-.932-1.36Z",
    transform: "translate(-5224.008 2929.932)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11504",
    "data-name": "Group 11504",
    transform: "translate(-3601.251 3447.687)",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10075",
    "data-name": "Rectangle 10075",
    width: 9.351,
    height: 14.944,
    transform: "translate(0.168 0)",
    fill: "url(#linear-gradient-95)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11506",
    "data-name": "Group 11506",
    transform: "translate(-3599.533 3447.687)",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10076",
    "data-name": "Rectangle 10076",
    width: 7.618,
    height: 13.958,
    transform: "translate(0.157 0)",
    fill: "url(#linear-gradient-96)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14093",
    "data-name": "Path 14093",
    d: "M.178,0,.334,0,.156,15.768,0,15.77Z",
    transform: "matrix(0.875, -0.484, 0.484, 0.875, -3601.219, 3448.835)",
    fill: "#d4a600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11508",
    "data-name": "Group 11508",
    transform: "translate(-3593.874 3461.003)",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10078",
    "data-name": "Rectangle 10078",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-97)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-119",
    "data-name": "SVGID",
    d: "M0,.019,1.693,0l0,.241L0,.26Z",
    transform: "translate(-3594.36 3460.899) rotate(-28.971)",
    fill: "#ffd801"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11510",
    "data-name": "Group 11510",
    transform: "translate(-3594.36 3460.079)",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10079",
    "data-name": "Rectangle 10079",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11512",
    "data-name": "Group 11512",
    transform: "translate(-3594.845 3459.155)",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10080",
    "data-name": "Rectangle 10080",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-99)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11514",
    "data-name": "Group 11514",
    transform: "translate(-3595.332 3458.231)",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10081",
    "data-name": "Rectangle 10081",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11516",
    "data-name": "Group 11516",
    transform: "translate(-3595.817 3457.307)",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10082",
    "data-name": "Rectangle 10082",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-101)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11518",
    "data-name": "Group 11518",
    transform: "translate(-3596.303 3456.383)",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10083",
    "data-name": "Rectangle 10083",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-101)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11520",
    "data-name": "Group 11520",
    transform: "translate(-3596.789 3455.459)",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10084",
    "data-name": "Rectangle 10084",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-101)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11522",
    "data-name": "Group 11522",
    transform: "translate(-3597.275 3454.535)",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10085",
    "data-name": "Rectangle 10085",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-101)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11524",
    "data-name": "Group 11524",
    transform: "translate(-3597.76 3453.61)",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10086",
    "data-name": "Rectangle 10086",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-105)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11526",
    "data-name": "Group 11526",
    transform: "translate(-3598.246 3452.686)",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10087",
    "data-name": "Rectangle 10087",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-106)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11528",
    "data-name": "Group 11528",
    transform: "translate(-3598.732 3452.041)",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10088",
    "data-name": "Rectangle 10088",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-107)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11530",
    "data-name": "Group 11530",
    transform: "translate(-3599.218 3451.142)",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10089",
    "data-name": "Rectangle 10089",
    width: 1.583,
    height: 1.047,
    transform: "translate(0.012 0)",
    fill: "url(#linear-gradient-108)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11532",
    "data-name": "Group 11532",
    transform: "translate(-3599.708 3450.237)",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10090",
    "data-name": "Rectangle 10090",
    width: 1.74,
    height: 1.338,
    transform: "translate(0.015 0)",
    fill: "url(#linear-gradient-109)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11534",
    "data-name": "Group 11534",
    transform: "translate(-3600.4 3448.964)",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10091",
    "data-name": "Rectangle 10091",
    width: 2.024,
    height: 1.866,
    transform: "translate(0.021 0)",
    fill: "url(#linear-gradient-110)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11536",
    "data-name": "Group 11536",
    transform: "translate(-3600.743 3448.322)",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10092",
    "data-name": "Rectangle 10092",
    width: 1.692,
    height: 1.25,
    transform: "translate(0.014 0)",
    fill: "url(#linear-gradient-111)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaasSmall);
export default __webpack_public_path__ + "static/media/maas-small.b940933e8240c6ae8960a19289a951c3.svg";
export { ForwardRef as ReactComponent };